import { useMemo } from "react";
import useCustomerMenu from "../../hooks/useCustomerMenu";
import { getMenuThemeComponent } from "./themes/registry";
import useJsonLd from "../../seo/useJsonLd";
import { buildRestaurantSchema } from "../../seo/schemaBuilders";

function MenuDisplayPage() {
  const menu = useCustomerMenu();
  const { loading, error, retry, menuData, theme, restaurant } = menu;

  // This endpoint (useCustomerMenu) only ever returns data for a restaurant
  // with a currently published menu, so no separate publish check is needed
  // here the way the /restaurant/:id page needs one.
  const restaurantSchema = useMemo(() => buildRestaurantSchema(restaurant), [restaurant]);
  useJsonLd("restaurant", restaurantSchema);

  if (loading) {
    return <div className="min-h-screen bg-gray-50 p-4" dir="rtl" aria-label="در حال بارگذاری منو"><div className="mx-auto max-w-5xl animate-pulse space-y-4"><div className="h-16 rounded-xl bg-gray-200" /><div className="h-40 rounded-2xl bg-gray-200" /><div className="grid gap-3 sm:grid-cols-2"><div className="h-32 rounded-2xl bg-gray-200" /><div className="h-32 rounded-2xl bg-gray-200" /></div></div></div>;
  }

  if (error) {
    return <main className="flex min-h-screen items-center justify-center bg-gray-50 p-4 text-center" dir="rtl"><div className="max-w-sm rounded-2xl border border-red-100 bg-white p-6"><p className="font-bold text-gray-900">نمایش منو ممکن نیست</p><p className="mt-2 text-sm text-gray-600">{error}</p><button type="button" onClick={retry} className="mt-5 min-h-11 rounded-xl bg-primary px-5 text-sm font-bold text-white">تلاش دوباره</button></div></main>;
  }

  if (!menuData) return null;

  const ThemeComponent = getMenuThemeComponent(theme);
  return <ThemeComponent {...menu} />;
}

export default MenuDisplayPage;
